import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var IllustratorSvg = function IllustratorSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#300",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A00",
    d: "m8.127 16.166.758-2.117h3.232l.752 2.117h1.424l-3.028-8.435h-1.54l-3.027 8.435zm3.634-3.377H9.223l1.272-3.68zm5.139-3.71V7.737h-1.406V9.08zm-.023 7.087v-6.031h-1.36v6.031z"
  }));
};
export var Illustrator = function Illustrator(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: IllustratorSvg
  }));
};